import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Container(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Container", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m22.125 15.45-1.2.9c-.45-.6-.675-1.35-.675-2.1 0-.375.375-.75.75-.75s.75.375.75.75c0 .45.15.825.375 1.2Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.75 27c-.15 0-.3-.075-.45-.15L24.45 16.2c-.225-.15-.6-.15-.9 0L8.7 26.85c-.3.225-.825.15-1.05-.15-.225-.3-.15-.825.15-1.05L22.725 15c.75-.525 1.8-.525 2.625 0L40.2 25.65c.3.225.45.675.15 1.05-.15.225-.375.3-.6.3Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "m23.326 16.425-1.35.975c-.45-.3-.825-.675-1.05-1.05l1.2-.9c.225.45.675.75 1.2.975Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M39.75 43.5H8.25c-.825 0-1.5-.675-1.5-1.5V27c0-.825.675-1.5 1.5-1.5h31.5c.825 0 1.5.675 1.5 1.5v15c0 .825-.675 1.5-1.5 1.5Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M11.25 39.75h-.75c-.45 0-.75-.3-.75-.75v-9c0-.45.3-.75.75-.75h.75c.45 0 .75.3.75.75v9c0 .45-.3.75-.75.75Zm5.25 0h-.75c-.45 0-.75-.3-.75-.75v-9c0-.45.3-.75.75-.75h.75c.45 0 .75.3.75.75v9c0 .45-.3.75-.75.75Zm5.25 0H21c-.45 0-.75-.3-.75-.75v-9c0-.45.3-.75.75-.75h.75c.45 0 .75.3.75.75v9c0 .45-.3.75-.75.75Zm5.25 0h-.75c-.45 0-.75-.3-.75-.75v-9c0-.45.3-.75.75-.75H27c.45 0 .75.3.75.75v9c0 .45-.3.75-.75.75Zm5.25 0h-.75c-.45 0-.75-.3-.75-.75v-9c0-.45.3-.75.75-.75h.75c.45 0 .75.3.75.75v9c0 .45-.3.75-.75.75Zm5.25 0h-.75c-.45 0-.75-.3-.75-.75v-9c0-.45.3-.75.75-.75h.75c.45 0 .75.3.75.75v9c0 .45-.3.75-.75.75Z",
        fill: theme.vars.palette.secondary.main
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27.75 14.25c0 .75-.225 1.5-.6 2.1-.3.45-.675.75-1.05 1.05-.6.375-1.35.6-2.1.6s-1.5-.225-2.025-.6l1.35-.975c.225.075.45.075.675.075.225 0 .45 0 .675-.075.525-.15.975-.525 1.2-.975.225-.375.375-.75.375-1.2 0-1.275-.975-2.25-2.25-2.25-.375 0-.75-.375-.75-.75V9c0-.375.375-.75.75-.75s.75.375.75.75v1.575c1.725.375 3 1.875 3 3.675Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M25.8 3h-3.6c-.3 0-.525.15-.675.45L20.4 5.7a1.04 1.04 0 0 0 0 .675l1.125 2.25c.15.225.375.45.675.45h3.6c.3 0 .525-.15.675-.45l1.125-2.25a1.04 1.04 0 0 0 0-.675l-1.125-2.25c-.15-.3-.375-.45-.675-.45Z",
        fill: theme.vars.palette.primary.dark
      }
    )
  ] });
}
Container.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Container"
};
validateTidalLicense();
export {
  Container
};
//# sourceMappingURL=Container.js.map
